interface PluralizeParameter {
  word: string;
  quantity: number;
  pluralWord?: string;
}

export function pluralize({
  word,
  quantity,
  pluralWord = `${word}s`,
}: PluralizeParameter) {
  if (quantity === 1) {
    return word;
  }
  return pluralWord;
}
